/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import { ExpansionPanel } from '@ferris/react/components/expansion-panel';
import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';

// Process the answer string to add tab space and line breaks
const processAnswer = (answer) => {
    // Handle the links
    const regexLink = /<a href="(.*?)">(.*?)<\/a>/g;
    const regexBold = /<b>(.*?)<\/b>/g;
    let lastEnd = 0;
    const parts = [];
    let matchLink = regexLink.exec(answer);
    let matchBold = regexBold.exec(answer);
    while (matchLink || matchBold) {
        let match;
        if (matchLink && matchBold) {
            match = matchLink.index < matchBold.index ? matchLink : matchBold;
        } else {
            match = matchLink || matchBold;
        }
        // Add the text before the tag
        if (match.index !== lastEnd) {
            parts.push(answer.substring(lastEnd, match.index));
        }
        if (match === matchLink) {
            // Add the link
            parts.push(<a href={match[1]} key={match[1]} target="_blank" rel="noreferrer">{match[2]}</a>);
            matchLink = regexLink.exec(answer);
        } else if (match === matchBold) {
            // Add the bold text
            parts.push(<b key={match.index}>{match[1]}</b>);
            matchBold = regexBold.exec(answer);
        }
        lastEnd = match.index + match[0].length;
    }
    // Add the text after the last tag
    if (lastEnd !== answer.length) {
        parts.push(answer.substring(lastEnd));
    }

    // Handle the <br> and <tb> replacements
    return parts.map(part => (typeof part === 'string'
        ? part
            .split('<br>')
            .map(
                line => line
                    .split('<tb>')
                    .map((segment, segmentIndex) => (segmentIndex === 0 ? segment : [<span key={segmentIndex} className="tab-space" />, segment]))
            )
            .reduce((prevLines, currentLine, lineIndex) => [...prevLines, lineIndex > 0 && <br key={lineIndex} />, ...currentLine], [])
        : part)); // Leave the <a> and <b> elements as they are
};

const CustomExpansionPanel = forwardRef(({ onToggle, question, answer }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            setIsOpen(!isOpen);
            onToggle(!isOpen);
        }
    };

    return (
        <div ref={ref} tabIndex={-1}>
            <ExpansionPanel
                open={isOpen}
                classes="expansion-panel"
                title={(
                    <span className="expansion-panel-title" itemProp="name">
                        {question}
                    </span>
                )}
                titleStyle="500"
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
                onToggle={onToggle}
                tabIndex={0}
                onKeyDown={onKeyDown}
            >
                <p className="answer" itemProp="text">
                    {processAnswer(answer)}
                </p>
            </ExpansionPanel>
        </div>
    );
});

CustomExpansionPanel.propTypes = {
    onToggle: PropTypes.func.isRequired,
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
};

export default CustomExpansionPanel;
